import React, { useMemo } from "react";
import styles from "./index.module.scss";
import { sendMessageToParent } from "../../utils";
import { isMobile } from "react-device-detect";

interface FeatureItem {
  icon: string;
  title: string;
  desc?: {
    title: string;
    content: any;
  };
  id?: string;
}

const features_m: FeatureItem[] = [
  {
    icon: "https://cdn.shopify.com/s/files/1/0506/5284/0124/files/Points-Redeem-Gift_Card.png?v=1744707143",
    title: "Points Redeem<br />Gift Card",
    id: "points-redeem-gift-card_m",
    desc: {
      title: "Points Redeem Gift Card",
      content: `
        <a href="/pages/ogl-membership-faqs"><img src="https://cdn.shopify.com/s/files/1/0506/5284/0124/files/points-redeem-gift-card.png?v=1746511044" height="164" width="230" /></a>
      `,
    },
  },
  {
    icon: "https://cdn.shopify.com/s/files/1/0506/5284/0124/files/Monthly-Free-Shipping-Coupon.png?v=1744707143",
    title: "Monthly Free<br />Shipping Coupon",
    id: "monthly-free-shipping-coupon_m",
    desc: {
      title: "Monthly Free Shipping Coupon",
      content: `Enjoy a special shipping coupon every month, valid for 30 days.`,
    },
  },
  {
    icon: "https://cdn.shopify.com/s/files/1/0506/5284/0124/files/Coupon-Rewards.png?v=1744707143",
    title: "Coupon<br />Rewards",
    id: "coupon-rewards_m",
    desc: {
      title: "Coupon Rewards",
      content: `
        <a href="/pages/ogl-membership-faqs"><img src="https://cdn.shopify.com/s/files/1/0506/5284/0124/files/coupon-rewards_f28e1e10-e908-4de2-adf1-8a2c06740faf.png?v=1746511044" height="70" width="200" /></a>
      `,
    },
  },
  {
    icon: "https://cdn.shopify.com/s/files/1/0506/5284/0124/files/Exclusive-Sale-Access.png?v=1744707143",
    title: "Exclusive Sale<br />Access",
    id: "exclusive-sale-access_m",
    desc: {
      title: "Exclusive Sale Access",
      content: `Be among the first to discover our private pre-sales and exclusive discounts on the latest trends.`,
    },
  },
  {
    icon: "https://cdn.shopify.com/s/files/1/0506/5284/0124/files/VIP-Customer-Service.png?v=1744707143",
    title: "VIP Customer<br />Service",
    id: "vip-customer-service_m",
    desc: {
      title: "VIP Customer Service",
      content:
        "Count on your personal account manager to help you and enjoy seamless logistics tracking.",
    },
  },
  {
    icon: "https://cdn.shopify.com/s/files/1/0506/5284/0124/files/365-days-Return-_-Exchange.png?v=1744707143",
    title: "365 days Return <br />& Exchange",
    id: "365-days-return-exchange_m",
    desc: {
      title: "365 days Return & Exchange",
      content: `Enjoy global hassle-free returns within 365 days, with OGL member priority processing.`,
    },
  },
];

const features_pc: FeatureItem[] = [
  {
    icon: "https://cdn.shopify.com/s/files/1/0506/5284/0124/files/Points-Redeem-Gift_Card.png?v=1744707143",
    title: "Points Redeem<br />Gift Card",
    id: "points-redeem-gift-card__pc",
    desc: {
      title: "Points Redeem Gift Card",
      content: `
        <a href="/pages/ogl-membership-faqs"><img src="https://cdn.shopify.com/s/files/1/0506/5284/0124/files/points-redeem-gift-card.png?v=1746511044" height="164" width="230" /></a>
      `,
    },
  },
  {
    icon: "https://cdn.shopify.com/s/files/1/0506/5284/0124/files/Monthly-Free-Shipping-Coupon.png?v=1744707143",
    title: "Monthly Free<br />Shipping Coupon",
    id: "monthly-free-shipping-coupon__pc",
    desc: {
      title: "Monthly Free Shipping Coupon",
      content: `Enjoy a special shipping coupon every month, valid for 30 days.`,
    },
  },
  {
    icon: "https://cdn.shopify.com/s/files/1/0506/5284/0124/files/Coupon-Rewards.png?v=1744707143",
    title: "Coupon<br />Rewards",
    id: "coupon-rewards__pc",
    desc: {
      title: "Coupon Rewards",
      content: `
        <a href="/pages/ogl-membership-faqs"><img src="https://cdn.shopify.com/s/files/1/0506/5284/0124/files/coupon-rewards_f28e1e10-e908-4de2-adf1-8a2c06740faf.png?v=1746511044" height="70" width="200" /></a>
      `,
    },
  },
  {
    icon: "https://cdn.shopify.com/s/files/1/0506/5284/0124/files/Exclusive-Sale-Access.png?v=1744707143",
    title: "Exclusive Sale<br />Access",
    id: "exclusive-sale-access__pc",
    desc: {
      title: "Exclusive Sale Access",
      content: `Be among the first to discover our private pre-sales and exclusive discounts on the latest trends.`,
    },
  },
  {
    icon: "https://cdn.shopify.com/s/files/1/0506/5284/0124/files/VIP-Customer-Service.png?v=1744707143",
    title: "VIP Customer<br />Service",
    id: "vip-customer-service__pc",
    desc: {
      title: "VIP Customer Service",
      content:
        "Count on your personal account manager to help you and enjoy seamless logistics tracking.",
    },
  },
  {
    icon: "https://cdn.shopify.com/s/files/1/0506/5284/0124/files/365-days-Return-_-Exchange.png?v=1744707143",
    title: "365 days Return <br />& Exchange",
    id: "365-days-return-exchange__pc",
    desc: {
      title: "365 days Return & Exchange",
      content: `Enjoy global hassle-free returns within 365 days, with OGL member priority processing.`,
    },
  },
];

const MemberFeatures: React.FC = () => {
  const features = useMemo(() => {
    return isMobile ? features_m : features_pc;
  }, []);

  const handleFeatureClick = (feature: FeatureItem) => {
    const viewMore = `
      <div style="display: flex; justify-content: center; align-items: center; margin-top: 22px;">
          <a style="font-size: 14px; color: #764B39; text-decoration: underline;" href="/pages/ogl-membership-faqs">View More Details</a>
      </div>
    `;
    sendMessageToParent({
      type: "member-drawer",
      data: {
        title: feature?.desc?.title,
        content: feature?.desc?.content + viewMore,
      },
    });
  };

  return (
    <div className={styles.memberFeatures}>
      <div className={styles.featuresGrid}>
        {features.map((feature, index) => (
          <div
            key={index}
            className={styles.featureItem}
            data-element-id={feature.id}
            onClick={() => handleFeatureClick(feature)}
          >
            <div className={`${styles.featureIcon}`}>
              <img src={feature.icon} alt={feature.title} />
            </div>
            <div className={styles.featureTitle}>
              <div dangerouslySetInnerHTML={{ __html: feature.title }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MemberFeatures;
